import { render, staticRenderFns } from "./modal-json.vue?vue&type=template&id=b3d24490&scoped=true"
import script from "./modal-json.vue?vue&type=script&lang=js"
export * from "./modal-json.vue?vue&type=script&lang=js"
import style0 from "./modal-json.vue?vue&type=style&index=0&id=b3d24490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d24490",
  null
  
)

export default component.exports